export default "__VITE_ASSET__BFQVwD0t__"